import { render, staticRenderFns } from "./Send.vue?vue&type=template&id=1fca261b&scoped=true&"
import script from "./Send.vue?vue&type=script&lang=js&"
export * from "./Send.vue?vue&type=script&lang=js&"
import style0 from "./Send.vue?vue&type=style&index=0&id=1fca261b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fca261b",
  null
  
)

export default component.exports